<template>
	<div class="page-login">
		<div class="container">
			<div class="login">
				<!-- <h3 class="login-title animated fadeIn">Sign in to Ostock.id</h3> -->
				<!-- <p>Enter your <b>email address</b> and <b>password</b></p> -->

				<!-- Login Box -->
				<template v-if="!isShowResetPassword">
					<div class="login-box">
						<ul class="nav nav-tabs nav-fill">
							<li class="nav-item">
								<router-link class="nav-link active" to="/login">
									Sign In
								</router-link>
							</li>
							<li class="nav-item">
								<router-link class="nav-link" to="/register">
									Sign Up
								</router-link>
							</li>
						</ul>
						<!-- <div class="login-box-logo">
							<img :src="`/img/${appLogo}`" class="d-block m-auto" :alt="appName">
						</div> -->
						<div class="login-wrapper p-5">
							<div class="h4 font-weight-bold mb-4">
								Sign In
							</div>

							<div class="mb-4">
								<button
									type="button"
									class="btn btn-light btn-block text-uppercasex" :class="{ 'is-loading': pending || !isInitialized }"
									@click="redirectOOLogin()">
									<img class="mr-2" :src="`/img/oo-icon.svg`" width="15px" alt="OO">
									<span>{{ $t('Sign In With OrderOnline') }}</span>
								</button>
							</div>

							<div class="mb-3">
								<small>OR SIGN IN USING EMAIL</small>
							</div>

							<div class="login-error callout callout--danger" v-if="loginError">
								<div class="callout__content">{{ loginError }}</div>
							</div>
							<form @submit.prevent="login({ email, password })">
								<div class="form-group">
									<input type="email" name="email" class="form-control" placeholder="Email" v-model="email" required>
								</div>
								<div class="form-group">
									<input type="password" name="password" class="form-control" placeholder="Password" v-model="password" required>
								</div>
								<div class="form-group d-flex justify-content-center">
									<recaptcha v-if="isGoogleRecaptchaEnabled" ref="recaptcha"></recaptcha>
								</div>
								<button type="submit" class="btn btn-submit btn-primary btn-block" :class="{ 'is-loading': pending || !isInitialized }">{{ $t('Sign in') }}</button>
							</form>
							<div class="text-right">
								<a class="login-action" @click="showResetPassword">{{ $t('Forgot Password') }}?</a>
							</div>
						</div>
					</div>
					<!-- <div class="auth-bottom-text hidden">
						<span>Doesn't have an account? </span>
						<a href="https://buy.ostock.id/free-account?utm_source=orderonline&utm_medium=login&utm_content=text" target="_blank">Create Free Account</a>
					</div> -->
				</template>

				<!-- Reset Password -->
				<div class="login-box p-5" v-if="isShowResetPassword">
					<div class="login-box-logo">
						<img :src="appLogo" class="d-block m-auto" :alt="appName">
					</div>
					<div class="login-error callout callout--danger" v-if="resetPasswordError">
						<div class="callout__content">{{ resetPasswordError }}</div>
					</div>
					<div class="login-error callout callout--success" v-if="resetPasswordSuccess">
						<div class="callout__title">{{ $t('Please Check Your Email') }}</div>
						<div class="callout__content">{{ $t('If your email is registered in Ostock.id, you will receive a link to reset your password in your email inbox') }}</div>
					</div>
					<form @submit.prevent="resetPassword({ email, password })">
						<div class="form-group">
							<input type="email" name="email" class="form-control" :placeholder="$t('Your Email Address')" v-model="email" required>
						</div>
						<button type="submit" class="btn btn-submit btn-primary btn-block" :class="{ 'is-loading': isResettingPassword }">
							{{ $t('Reset Password') }}
						</button>
					</form>
					<div class="text-right">
						<a class="login-action" @click="showLogin">
							{{ $t('Back to Login') }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Axios from 'axios';
import userApi from '../api/user';
import { getOS, getDeviceType, getBrowser, duplicateVar } from '../lib/helper';
import Recaptcha from '@/components/Recaptcha.vue';

const base_url = process.env.VUE_APP_BASE_URL || 'https://ostock.id';

export default {
	name: 'login',
	components: {
		Recaptcha,
	},
	data() {
		return {
			title: 'Login',
			email: '',
			password: '',
			isShowResetPassword: false,
			isResettingPassword: false,
			resetPasswordError: false,
			resetPasswordSuccess: false,
			ip: null,
			location: '',
			position: null,
			latitude: 0,
			longitude: 0,
			isLocating: false,
			locationData: null,
			isLocationFetched: true,
		};
	},
	methods: {
		...mapActions({
		}),
		getIp() {
			const endpoint = 'https://public.orderonline.id/ip';
			Axios.get(endpoint)
				.then((response) => {
					const ip = response.data.ip;
					this.ip = ip;
				})
				.catch(() => {
					this.isLocationFetched = true;
				});
		},
		getLocation() {
			this.isLocating = true;
			if (navigator.geolocation) {
				const onSuccess = (pos) => {
					this.position = duplicateVar(pos);
					const lat = pos.coords.latitude;
					const long = pos.coords.longitude;
					this.latitude = lat;
					this.longitude = long;
					this.isLocating = false;
				};
				const onError = () => {
					this.isLocating = false;
				};
				navigator.geolocation.getCurrentPosition(onSuccess, onError);
			} else {
				this.isLocating = false;
			}
		},
		login() {
			const gRecaptchaResponse = document.getElementsByName('g-recaptcha-response')[0]?.value ?? '';

			if (this.isGoogleRecaptchaEnabled && gRecaptchaResponse === '') {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Recaptcha harus diisi.',
				});
			} else {
				const metaJson = JSON.stringify(this.meta);
				const payload = {
					creds: {
						email: this.email,
						password: this.password,
						meta: metaJson,
						g_recaptcha: gRecaptchaResponse,
					},
				};
				if (this.referrer && this.referrer !== '') {
					payload.redirectPath = this.referrer;
				}
				this.$store.dispatch('login', payload);
			}
		},
		resetPassword() {
			this.isResettingPassword = true;
			const callback = () => {
				this.isResettingPassword = false;
				this.resetPasswordSuccess = true;
			};
			const errorCallback = () => {
				this.isResettingPassword = false;
			};
			userApi.resetPassword(this.email, callback, errorCallback);
		},
		showResetPassword(event) {
			event.preventDefault();
			this.isShowResetPassword = true;
		},
		showLogin() {
			this.isShowResetPassword = false;
		},
		onClick() {
			if (this.isLocating) {
				this.isLocating = false;
			}
		},
		redirectOOLogin() {
			window.location = `${this.ooWeb}/auth/ostock?callback=${base_url}/auth/callback`;
		},
		handleOOLogin() {
			const userId = this.$route.query.uid;
			let ref = this.$route.query.ref;
			const encryptedToken = this.$route.query.secret;
			if (userId && encryptedToken) {
				if (ref === null || ref === '') {
					ref = 'orderonline'
				}

				const token = window.atob(encryptedToken)
				window.location.href = `/auth/callback?oo_user=${userId}&token=${token}&ref=${ref}`;
			}
		}
	},
	computed: {
		...mapGetters({
			pending: 'pending',
			loginError: 'loginError',
			appName: 'appName',
			appLogo: 'appLogo',
			ooWeb: 'ooWeb',
			isGoogleRecaptchaEnabled: 'isGoogleRecaptchaEnabled',
		}),
		action() {
			const action = this.$route.query.action;
			return action;
		},
		isInitialized() {
			// return !!this.ip && !this.isLocating && this.isLocationFetched;
			return true;
		},
		meta() {
			const os = getOS();
			const deviceType = getDeviceType();
			const browser = getBrowser();
			const location = this.location;
			const userAgent = window.navigator.userAgent;
			const meta = {
				ip: this.ip,
				os,
				device: deviceType,
				browser,
				location,
				lat: this.latitude,
				long: this.longitude,
				user_agent: userAgent,
			};
			return meta;
		},
		referrer() {
			return this.$route.query ? this.$route.query.ref : false;
		},
	},
	created() {
		this.handleOOLogin();
		document.body.classList.add('login');
		this.getIp();
		this.getLocation();
		if (this.action && this.action === 'forgot_password') {
			this.isShowResetPassword = true;
		}
		document.addEventListener('click', this.onClick);
	},
	destroyed() {
		document.body.classList.remove('login');
		document.removeEventListener('click', this.onClick);
	},
	watch: {
		ip() {
			if (this.ip) {
				const geoApiKey = process.env.VUE_APP_GEODB_API_KEY;
				const endpoint = `https://geolocation-db.com/json/${geoApiKey}/${this.ip}`;
				Axios.get(endpoint)
					.then(({ data }) => {
						this.locationData = data;
						const city = data.city || 'Unknown city';
						const country = data.country_name || 'Unknown country';
						const location = `${city}, ${country}`;
						this.location = location;
						this.isLocationFetched = true;
					})
					.catch(() => {
						this.isLocationFetched = true;
					});
			}
		},
		loginError() {
			if (typeof window.grecaptcha !== 'undefined'){
				window.grecaptcha.reset();
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar-brand {
	margin: 0 auto;
}

.login {
	padding-top: 4em;
	text-align: center;
}

h3 {
	font-weight: 300;
}

.login-box {
	margin: 2em auto;
	// padding: 0 2.5em 2.5em 2.5em;
	max-width: 420px;
	background-color: #fff;
	border-radius: 5px;
	// border: 1px solid #d7d7da;
	box-shadow: 0 1px 10px -4px #9c9c9c;

	@media (max-width: 575px) {
		margin-top: 0;
		padding: 1em;
		box-shadow: none;
	}
}

.login-box-logo {
	margin: 0 auto;
	margin-bottom: 2em;
	max-width: 210px;

	img {
		max-width: 100%;
		height: auto;
	}
}

.login-error {
	margin-bottom: 2em;
	font-size: .95em;
}

.login-action {
	display: inline-block;
	margin-top: 1em;
	// color: #75cfd8 !important;
	cursor: pointer;

	&:hover {
		text-decoration: underline !important;
	}
}

.btn-submit {
	padding-top: .5em;
	padding-bottom: .5em;
	font-weight: 600;
	text-transform: uppercase;
}

.nav-tabs {
	border-bottom: 0px solid transparent;

	.nav-link {
		border: 0px solid transparent;
		padding: 0.7rem 1rem;
	}

	:last-child{
		.nav-link {
			border-right: none;
			border-top-right-radius: 5px;
		}
	}
}
</style>
